var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLastPerformedCoachIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1415_2926)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.00007 12.25L9.62507 5.83333M10.2784 1.99675L9.41157 5.25C9.38823 5.33698 9.39737 5.42948 9.43729 5.51021C9.47721 5.59094 9.54518 5.65436 9.62847 5.6886C9.71176 5.72285 9.80468 5.72558 9.88984 5.69628C9.975 5.66698 10.0466 5.60766 10.0912 5.52942L11.7618 2.60575C11.8187 2.50599 11.8537 2.39525 11.8645 2.2809C11.8752 2.16656 11.8614 2.05124 11.8241 1.94263C11.7867 1.83402 11.7267 1.73463 11.6479 1.65107C11.5691 1.56752 11.4734 1.50172 11.3671 1.45808C11.2609 1.41443 11.1466 1.39393 11.0318 1.39796C10.917 1.40198 10.8044 1.43043 10.7015 1.4814C10.5986 1.53238 10.5077 1.60471 10.435 1.69357C10.3622 1.78244 10.3092 1.88579 10.2796 1.99675M4.35816 10.0701L7.00007 12.2348C6.7784 12.4623 6.56549 12.6957 6.25224 12.7872C6.09474 12.8333 5.92674 12.8333 5.58957 12.8333H3.8769C2.98907 12.8333 2.15607 12.5498 1.84282 11.6287C1.54824 10.7631 1.95541 9.32692 3.05615 9.33333C3.46215 9.33567 3.76082 9.58067 4.35816 10.0701Z",
    stroke: "#006AB3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1415_2926"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastPerformedCoachIcon);
export default __webpack_public_path__ + "static/media/last_performed_coach_icon.4c0a47368136822495180e93c555940d.svg";
export { ForwardRef as ReactComponent };